export enum RatingStatus {
  PUBLISH = 'PUBLISH',
  REMOVED_BY_COMPANY_POLICIES = 'REMOVED_BY_COMPANY_POLICIES',
  WAITING_APPROVAL = 'WAITING_APPROVAL',
  REMOVED_BY_ADMIN = 'REMOVED_BY_ADMIN',
  IN_REVIEW_REQUESTED_BY_PARTNER = 'IN_REVIEW_REQUESTED_BY_PARTNER',
  REMOVED_BY_IA = 'REMOVED_BY_IA',
  ALL = 'ALL', // Utilizado para montar filtro
}



// WEBPACK FOOTER //
// ./src/app/pages/rating/enums/rating-status.enum.ts